import React from 'react'
import cx from 'classnames'

import S from './styled'

class Slider extends React.Component {

  state = {
    value: this.props.value,
    isPressed: false,
  }

  static defaultProps = {
    step: 5,
  }

  componentDidUpdate(prevProps) {
    if (this.props.value !== prevProps.value && this.state.value !== this.props.value) {
      this.setState({
        value: this.props.value,
      })
    }
  }

  setRef = element => {
    this.element = element
  }

  fireEvent = value => {
    if(this.props.value !== value) {
      this.props.onChange && this.props.onChange({
        target: {
          name: this.props.name,
          value,
        },
      })
    }
  }

  handleTouchStart = e => {
    const value = this.calcualateValue(e)
    this.fireEvent(value)
    this.setState({
      isPressed: true,
      value,
    })

    window.addEventListener('touchmove', this.handleTouchMove)
    window.addEventListener('touchend', this.handleTouchEnd)
  };

  handleTouchMove = e => {
    e.preventDefault()
    this.handleMouseMove(e.touches[0])
  }

  handleMouseDown = e => {
    const value = this.calcualateValue(e)
    this.fireEvent(value)

    this.setState({
      isPressed: true,
      value,
    })

    window.addEventListener('mousemove', this.handleMouseMove)
    window.addEventListener('mouseup', this.handleMouseUp)
  }

  getOffset = el => {
    let _x = 0
    let _y = 0
    while( el && !isNaN( el.offsetLeft ) && !isNaN( el.offsetTop ) ) {
      _x += el.offsetLeft - el.scrollLeft
      _y += el.offsetTop - el.scrollTop
      el = el.offsetParent
    }
    return { top: _y, left: _x }
  }

  roundtoStep = value =>  Math.round(value / this.props.step) * this.props.step

  calcualateValue = e => {
    const x = e.pageX
    const position = this.getOffset(this.element).left
    const width = this.element.offsetWidth
    const calculatedValue = (x - position) * 100 / width
    let value = Math.max(Math.min(this.roundtoStep(calculatedValue), 100), 0)

    if (this.props.min || this.props.min === 0) {
      value = Math.max(value, this.props.min + this.props.step)
    }

    if (this.props.max || this.props.max === 0) {
      value = Math.min(value, this.props.max - this.props.step)
    }

    return value
  }

  handleMouseMove = e => {
    const { isPressed } = this.state
    if (isPressed) {
      this.setState({ value: this.calcualateValue(e) })
    }
  }

  handleMouseUp = () => {
    this.fireEvent(this.state.value)

    this.setState({ isPressed: false })

    window.removeEventListener('mouseup', this.handleMouseUp)
    window.removeEventListener('mousemove', this.handleMouseMove)
  }

  handleTouchEnd = () => {
    this.fireEvent(this.state.value)
    this.setState({ isPressed: false })

    window.removeEventListener('touchmove', this.handleTouchMove)
    window.removeEventListener('touchend', this.handleTouchEnd)
  }

  render() {
    const { readOnly } = this.props
    return (
      <S.Slider className={readOnly ? 'readOnly' : ''}>
        <S.SliderTrack
          onMouseDown={readOnly ? null : e => this.handleMouseDown(e)}
          onTouchStart={readOnly ? null : e => this.handleTouchStart(e)}
          ref={this.setRef}
        >
          <S.SliderProgress
            style={{ width: this.state.value === 100 ? '101%' : `${this.state.value}%` }}
          >
            <S.ValueIndicator className={cx({
              moving: this.state.isPressed,
              correctLeft: this.state.value === 0,
            })}>
              {this.state.value}%
            </S.ValueIndicator>
          </S.SliderProgress>
        </S.SliderTrack>
      </S.Slider>
    )
  }
}

export default Slider
